"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapData = exports.filterSortData = exports.formatValue = exports.defaultFilteringOptions = exports.createCellStyle = exports.calculateContentPixelWidth = exports.listColumns = exports.ROW_PIXEL_HEIGHT = void 0;
var moment = require("moment");
var SokReducerTypes = require("@caddigital/sok-reducers/lib/types");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var Types = require("../types");
var text_1 = require("utils/text");
var BLANK = '—';
var ICON_COUNT = 4;
var ICON_REM_WIDTH = 2.5;
var REM = 13;
var FILTERING_TOOLS_REM_WIDTH = 4;
exports.ROW_PIXEL_HEIGHT = 50;
var uniqueColumnsForReportTemplateList = ['name'];
var listColumns = function (listEntryType) {
    var columns = [
        { prop: 'name', type: Types.ListColumnType.text },
        {
            prop: 'description',
            type: Types.ListColumnType.text
        },
        {
            prop: 'createdAt',
            type: Types.ListColumnType.date
        },
        {
            prop: 'createdBy',
            type: Types.ListColumnType.user
        },
        {
            prop: 'updatedAt',
            type: Types.ListColumnType.date
        },
        {
            prop: 'updatedBy',
            type: Types.ListColumnType.user
        },
        {
            prop: 'expiresAt',
            type: Types.ListColumnType.date
        }
    ];
    columns.forEach(function (column) {
        var key = uniqueColumnsForReportTemplateList.includes(column.prop) &&
            listEntryType === SokReducerTypes.TEMPLATE
            ? "template-".concat(column.prop)
            : column.prop;
        var caption = (0, translation_1.getLocalization)("management/reports/list/columns/".concat(key));
        column.caption = caption;
        // +7.5% correction for the boldface font (because who needs CSS?)
        column.pixelWidth = 1.075 * (0, text_1.calculateStringLength)(caption);
        column.pixelWidth += FILTERING_TOOLS_REM_WIDTH * REM;
    });
    return columns;
};
exports.listColumns = listColumns;
var calculateContentPixelWidth = function (columns) {
    var totalContentWidth = columns.reduce(function (acc, column) { var _a; return acc + ((_a = column.pixelWidth) !== null && _a !== void 0 ? _a : 0); }, 0);
    var totalIconWidth = ICON_COUNT * ICON_REM_WIDTH * REM;
    // (n - 1) gutters and overall left and right padding; 1rem each
    var totalPadding = (1 + columns.length) * REM;
    return totalContentWidth + totalIconWidth + totalPadding;
};
exports.calculateContentPixelWidth = calculateContentPixelWidth;
var createCellStyle = function (pixelWidth) { return ({
    width: "".concat(pixelWidth, "px"),
    minWidth: "".concat(pixelWidth, "px"),
    maxWidth: "".concat(pixelWidth, "px")
}); };
exports.createCellStyle = createCellStyle;
var defaultFilteringOptions = function () { return ({
    filters: [],
    sort: { prop: 'createdAt', order: 'desc' }
}); };
exports.defaultFilteringOptions = defaultFilteringOptions;
var formatUser = function (value) {
    var _a = value, firstName = _a.firstName, lastName = _a.lastName;
    return "".concat(firstName !== null && firstName !== void 0 ? firstName : String(), " ").concat(lastName !== null && lastName !== void 0 ? lastName : String()).trim() || BLANK;
};
var formatValue = function (value, type) {
    switch (type) {
        case Types.ListColumnType.date:
            return value
                ? moment(new Date(Number(value))).format('DD.MM.YYYY')
                : BLANK;
        case Types.ListColumnType.user:
            return value ? formatUser(value) : BLANK;
        case Types.ListColumnType.text:
            return value ? String(value) : BLANK;
    }
};
exports.formatValue = formatValue;
var filterData = function (data, filters) {
    return data.filter(function (report) {
        return filters.every(function (filter) {
            return String(report[filter.prop]).toLowerCase().includes(filter.value);
        });
    });
};
var sortData = function (data, sorting) {
    if (!sorting) {
        return data;
    }
    var prop = sorting.prop, order = sorting.order;
    return data.sort(function (a, b) {
        var aValue = String(a[prop]).toLowerCase();
        var bValue = String(b[prop]).toLowerCase();
        if (aValue < bValue) {
            return order === 'asc' ? -1 : 1;
        }
        if (aValue > bValue) {
            return order === 'asc' ? 1 : -1;
        }
        return 0;
    });
};
var filterSortData = function (data, filteringOptions) {
    return sortData(filterData(data, filteringOptions === null || filteringOptions === void 0 ? void 0 : filteringOptions.filters), filteringOptions === null || filteringOptions === void 0 ? void 0 : filteringOptions.sort);
};
exports.filterSortData = filterSortData;
var mapData = function (data, listEntryType) {
    var columns = (0, exports.listColumns)(listEntryType);
    var items = data.map(function (report) {
        var row = {
            status: report.status,
            uuid: report.uuid
        };
        columns.forEach(function (column) {
            var _a;
            var formattedValue = (0, exports.formatValue)(report[column.prop], column.type);
            column.pixelWidth = Math.max((_a = column.pixelWidth) !== null && _a !== void 0 ? _a : 0, (0, text_1.calculateStringLength)(formattedValue));
            row[column.prop] = formattedValue;
        });
        return row;
    });
    return { items: items, columns: columns };
};
exports.mapData = mapData;
